import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/classroom.png'


const _hoisted_1 = { class: "flex items-center space-x-2.5 py-1" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "relative" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {"width":"30px"}
  })
], -1)
const _hoisted_3 = { class: "flex items-center space-x-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  style: {"font-size":"18px !important"},
  class: "material-icons text-success"
}, "done", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.remoteObjectUrl ? 'a' : 'p'), {
          class: _normalizeClass({ 'hover:underline cursor-pointer': _ctx.remoteObjectUrl }),
          target: "_blank",
          href: _ctx.remoteObjectUrl
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              _createTextVNode(_toDisplayString(_ctx.$t("integrations.classroom.published_on_classroom")), 1)
            ])
          ]),
          _: 3
        }, 8, ["class", "href"])),
        _hoisted_4
      ])
    ])
  ]))
}